export default {
    setSearchFriend(state, payload) {
        state.searchFriend = payload;
    }
}